import Vue from 'vue';

export const BoolYesNoFilter = Vue.filter('boolYesNo', (value: boolean) => {
	return value ? "Yes" : "No";
});